'use client'

import { Anchor, Box, Button, Space, Stack, Text, Title } from '@mantine/core'
import { BlendCtaSection, BlendCtaType } from '@/app/_components/blend/Cta'
import { COURTYARD2_AUTH_LOGIN_PATH, COURTYARD2_AUTH_SIGNUP_PATH } from '@/constants'
import { authSignupContent, DONT_HAVE_ACCOUNT, LOG_IN, loginContent } from '@/text'

const { TITLE, SUBTITLE, TEXT } = loginContent

const { ALT_CREATE_ACCOUNT } = authSignupContent

export default function ExistingAccountLogin({
  isBlend = false,
  signupHref = COURTYARD2_AUTH_SIGNUP_PATH,
}: {
  isBlend?: boolean
  signupHref?: string
}) {
  return (
    <Box>
      <Stack gap="1">
        <Title
          pb="xs"
          style={{ color: 'var(--mantine-color-brand-blue-9)' }}
          order={1}
          fz={{ base: 36, md: 44, lg: 48 }}
          lh="1.2"
        >
          {TITLE}
        </Title>
        <Text fz={{ base: 'lg', md: 'xl' }} c={'brand-blue.9'} fw={700}>
          {SUBTITLE}
        </Text>
        <Text fz={{ base: 'md', md: 'lg' }} c={'brand-blue.9'}>
          {TEXT}
        </Text>
      </Stack>

      <Space h="xl" />
      <Space h="sm" />

      {isBlend ? (
        <BlendCtaSection ctaType={BlendCtaType.LOGIN} />
      ) : (
        <>
          <Button variant="primary" size="lg" fz={'md'} w="234px" component="a" href={COURTYARD2_AUTH_LOGIN_PATH}>
            {LOG_IN}
          </Button>
          <Space h="md" />
          <Text pt="xs" size="sm">
            {DONT_HAVE_ACCOUNT}{' '}
            <Anchor fw={700} href={signupHref}>
              {ALT_CREATE_ACCOUNT}
            </Anchor>
          </Text>
        </>
      )}
    </Box>
  )
}
